/* lua.js generated code 0.3.0 */

BaseItemDef = xClass("BaseItemDef")
BaseItemDef.prototype.initWithData = function (id, def) {
    var self = this
    self.id = tonumber(id)
    self.color = $or(def.color)
    self.special = $or(def.special)
    self.itemType = $or(def.itemType)
    self.strength = $or(def.strength)
    self.level = $or(def.level, 0)
    self.lockType = $or(def.lockType)
    self.coverType = $or(def.coverType)
    self.ceilType = $or(def.ceilType)
}
BaseItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    item.isUsed = true
    item.isEmpty = false
    if ($bool(self.itemType)) {
        item.itemType = self.itemType
    }
    if ($bool(self.color)) {
        item.itemColorType = self.color
    }
    if ($bool(self.lockType)) {
        item.lockType = self.lockType
    }
    if ($bool(self.special)) {
        item.itemSpecialType = self.special
    }
    if ($bool(self.coverType)) {
        item.coverType = self.coverType
    }
    if ($bool(self.ceilType)) {
        item.ceilType = self.ceilType
    }
}
BaseItemDef.prototype.initBoardItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
}
BaseItemDef.prototype.addedToGameBoard = function (gameItemData, mainLogic) {
    let self = this
    // body
}
BaseItemDef.prototype.initOrderData = function (order) { }
//------------------------------------------------------------------------
GameItemDef = xClass("GameItemDef", BaseItemDef)
GameItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemSpecialType !== AnimalTypeConfig.kColor && item.itemSpecialType !== AnimalTypeConfig.kSuperBird && item.itemSpecialType !== AnimalTypeConfig.kNuclear && item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
GameItemDef.prototype.initOrderData = function (order) {
    var self = this
    order.special = self.special
    order.color = self.color
}
//------------------------------------------------------------------------
AlienItemDef = xClass("AlienItemDef", GameItemDef)
GumItemDef = xClass("GumItemDef", GameItemDef)
GumItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor(true)
    }
}
//------------------------------------------------------------------------
PawItemDef = xClass("PawItemDef", GumItemDef)
PawItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor(true)
    }
}
//------------------------------------------------------------------------
CircleItemDef = xClass("CircleItemDef", BaseItemDef)
CircleItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//------------------------------------------------------------------------
EmptyItemDef = xClass("EmptyItemDef", BaseItemDef)
EmptyItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
}
//------------------------------------------------------------------------
EdgeItemDef = xClass("EdgeItemDef", BaseItemDef)
EdgeItemDef.prototype.initWithData = function (id, def) {
    var self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.strength = def.strength || 0
    self.itemType = def.itemType
}
EdgeItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // item.canRemoved = self.remove
    item.strength = self.strength
    item.itemType = self.itemType
}
//------------------------------------------------------------------------
IceItemDef = xClass("IceItemDef", BaseItemDef)
IceItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
}
IceItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.iceLevel = self.strength
}
//------------------------------------------------------------------------
LockItemDef = xClass("LockItemDef", BaseItemDef)
LockItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isBlock = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.cageLevel = 1
}
FishLockItemDef = xClass("FishLockItemDef", BaseItemDef)
FishLockItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.fishLock = 1
}
//------------------------------------------------------------------------
CoinItemDef = xClass("CoinItemDef", BaseItemDef)
CoinItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.itemColorType = 0
    item.itemSpecialType = 0
}
//------------------------------------------------------------------------
CrystalItemDef = xClass("CrystalItemDef", BaseItemDef)
CrystalItemDef.prototype.addedToGameBoard = function (gameItemData, mainLogic) {
    let self = this
    gameItemData.itemColorType = mainLogic.randomColor()
}
//---------------------------------------------------------------------------
SeaAnimalDef = xClass("SeaAnimalDef", BaseItemDef)
SeaAnimalDef.prototype.initWithData = function (id, def) {
    var self = this
    // body
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.width = def.width
    self.height = def.height
}
SeaAnimalDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.seaAnimalType = self.id
    board.seaAnimalWidth = self.width
    board.seaAnimalHeight = self.height
    mainLogic.addSeaAnimal(board)
}
SeaAnimalDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
}
//------------------------------------------------------------------------
SeaAnimalRandomAreaDef = xClass("SeaAnimalRandomAreaDef", BaseItemDef)
SeaAnimalRandomAreaDef.prototype.initWithData = function (id, def) {
    var self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.seaAnimalType = def.seaAnimalType
}
SeaAnimalRandomAreaDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
}
SeaAnimalRandomAreaDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    board.addRandomSeaAnimalMark(self.seaAnimalType)
}
//------------------------------------------------------------------------
FishDef = xClass("FishDef", BaseItemDef)
FishDef.prototype.initOrderData = function (order) {
    let self = this
    order.gameItemType = GameItemType.kFish
    order.color = null
    order.special = null
}
FishDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//------------------------------------------------------------------------
ColorBlockDef = xClass("ColorBlockDef", BaseItemDef)
ColorBlockDef.prototype.initWithData = function (id, def) {
    var self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
}
ColorBlockDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
}
ColorBlockDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.color = self.color
}
//------------------------------------------------------------------------
RoostItemDef = xClass("RoostItemDef", BaseItemDef)
RoostItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isBlock = true
    item.roostLevel = 1
}
//------------------------------------------------------------------------
HoneyBottleDef = xClass("HoneyBottleDef", BaseItemDef)
HoneyBottleDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.honeyBottleLevel = 3
    item.itemColorType = 0
}
//------------------------------------------------------------------------
HoneyItemDef = xClass("HoneyItemDef", BaseItemDef)
HoneyItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    item.isUsed = true
}
HoneyItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.honeyLevel = self.strength
}
//------------------------------------------------------------------------
StoneItemDef = xClass("StoneItemDef", BaseItemDef)
VarSnowItemDef = xClass("VarSnowItemDef", BaseItemDef)
VarSnowItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock() && item.lockType !== LockItemType.kMushroom) {
        showError(item.y, item.x, self)
        return 
    }
    item.var_snow_level = self.strength
}
//------------------------------------------------------------------------
FlowerVineItemDef = xClass("FlowerVineItemDef", BaseItemDef)
FlowerVineItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.flower_vine_level = self.strength
    if (self.strength === 1) {
        item.flowerVineWaitDeath = true
    }
}
MissileItemDef = xClass("MissileItemDef", BaseItemDef)
BossIgnoreAreaItemDef = xClass("BossIgnoreAreaItemDef", BaseItemDef)
BossIgnoreAreaItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
}
BossIgnoreAreaItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.bossIngoreArea = true
}
//------------------------------------------------------------------------
BossPreferAreaItemDef = xClass("BossPreferAreaItemDef", BaseItemDef)
BossPreferAreaItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
}
BossPreferAreaItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.bossPreferArea = true
}
//------------------------------------------------------------------------
BossNoneAreaItemDef = xClass("BossNoneAreaItemDef", BaseItemDef)
BossNoneAreaItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
}
BossNoneAreaItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.bossNoneArea = true
}
//------------------------------------------------------------------------
FurballItemDef = xClass("FurballItemDef", BaseItemDef)
FurballItemDef.prototype.initWithData = function (id, def) {
    var self = this
    // body
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.furballType = def.furballType
}
FurballItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.furballLevel = self.strength
    item.furballType = self.furballType
}
//------------------------------------------------------------------------
WaterBombItemDef = xClass("WaterBombItemDef", BaseItemDef)
WaterBombItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isBlock = true
}
//------------------------------------------------------------------------
DandelionItemDef = xClass("DandelionItemDef", BaseItemDef)
DandelionSeedItemDef = xClass("DandelionSeedItemDef", BaseItemDef)
SubmarineItemDef = xClass("SubmarineItemDef", BaseItemDef)
GatherItemDef = xClass("GatherItemDef", BaseItemDef)
GatherItemDef.prototype.initGameItem = function (item, mainLogic) { }
GatherItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.isGather = true
}
//------------------------------------------------------------------------
ReefItemDef = xClass("ReefItemDef", BaseItemDef)
ReefItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.reef_level = self.strength
}
//------------------------------------------------------------------------
BoatItemDef = xClass("BoatItemDef", BaseItemDef)
DigWaterItemDef = xClass("DigWaterItemDef", BaseItemDef)
DigWaterItemDef.prototype.initGameItem = function (item, mainLogic) { }
DigWaterItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self,board, mainLogic)
    board.isDigWater = true
}
//------------------------------------------------------------------------
SoilItemDef = xClass("SoilItemDef", BaseItemDef)
SoilItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    item.isUsed = true
}
SoilItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.soilLevel = self.strength
}
//------------------------------------------------------------------------
VariousBoxItemDef = xClass("VariousBoxItemDef", BaseItemDef)
VariousBoxItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isBlock = true
    item.variousBoxLevel = 1
}
//------------------------------------------------------------------------
FishClockItemDef = xClass("FishClockItemDef", BaseItemDef)
FishClockItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isBlock = true
}
//------------------------------------------------------------------------
StarfishItemDef = xClass("StarfishItemDef", BaseItemDef)
StarfishItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = GamePlayConfig_Ball_Strength
    item.isBlock = true
}
StarfishItemDef.prototype.addedToGameBoard = function (gameItemData, mainLogic) {
    let self = this
    // body
    if (gameItemData.itemColorType === 0) {
        gameItemData.itemColorType = mainLogic.randomColor(true)
    }
}
//------------------------------------------------------------------------
MoveTileDef = xClass("MoveTileDef", BaseItemDef)
MoveTileDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    item.isUsed = true
}
//------------------------------------------------------------------------
MissileHateAreaItemDef = xClass("MissileHateAreaItemDef", BaseItemDef)
MissileHateAreaItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
}
MissileHateAreaItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.missileDisgustArea = true
}
//------------------------------------------------------------------------
VenomItemDef = xClass("VenomItemDef", BaseItemDef)
VenomItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    item.isUsed = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.venomLevel = 1
}
//------------------------------------------------------------------------
VenomTroublesomeItemDef = xClass("VenomTroublesomeItemDef", BaseItemDef)
VenomTroublesomeItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
}
VenomTroublesomeItemDef.prototype.initBoardItem = function (board, mainLogic) {
    var self = this
    // body
    board.isUsed = true
    board.venomTroublesome = true
}
//------------------------------------------------------------------------
JellyfishItemDef = xClass("JellyfishItemDef", BaseItemDef)
JellyfishItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//------------------------------------------------------------------------
LightHouseItemDef = xClass("LightHouseItemDef", BaseItemDef)
LightHouseItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//------------------------------------------------------------------------
LotusItemDef = xClass("LotusItemDef", BaseItemDef)
LotusItemDef.prototype.initGameItem = function (item, mainLogic) {
    var self = this
    // body
    item.isUsed = true
    item.lotusLevel = 1
}
MagicItemDef = xClass("MagicItemDef", BaseItemDef)
MagicItemDef.prototype.initGameItem = function (item, mainLogic) { }
MagicItemDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.isMagic = true
}
RabbitItemDef = xClass("RabbitItemDef", BaseItemDef)
RabbitItemDef.prototype.initGameItem = function (item, mainLogic) { }
RabbitItemDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.isRabbit = true
}
SurfingCatItemDef = xClass("SurfingCatItemDef", BaseItemDef)
SurfingCatItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType == 0) {
        item.itemColorType = mainLogic.randomColor(true)
    }
}
SurfingCatItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = 1
    item.isBlock = true
}
PursueStartItemDef = xClass("PursueStartItemDef", BaseItemDef)
PursueStartItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = 0
}// ForbitRefreshDef
ForbitRefreshDef = xClass("ForbitRefreshDef", BaseItemDef)
ForbitRefreshDef.prototype.initGameItem = function (item, mainLogic) { }
ForbitRefreshDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.forbitRefresh = true
}
// ForbitRefreshDef
// kDisFourTile
DisFourTile = xClass("DisFourTile", BaseItemDef)
DisFourTile.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
}
DisFourTile.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    // print(debug.traceback())
    // debug.debug()
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.disFourTile = true
}
ColorCollectorItemDef = xClass("ColorCollectorItemDef", BaseItemDef)
ColorCollectorItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType == 0) {
        item.itemColorType = mainLogic.randomColor(true)
    }
}
ColorCollectorItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = 0
    item.isBlock = true
}//-----------------------------------------------------------------------
VarousBoxIgnoreAreaDef = xClass("VarousBoxIgnoreAreaDef", BaseItemDef)
VarousBoxIgnoreAreaDef.prototype.initWithData = function (id, def) {
    let self = this
    // body
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.varousIgnore = true
}
VarousBoxIgnoreAreaDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
}
VarousBoxIgnoreAreaDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    // body
    board.addVarousIgnoreMark(self.varousIgnore)
}
SurpriseBoxItemDef = xClass("SurpriseBoxItemDef", BaseItemDef)
SurpriseBoxItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    // 巧克力盒默认需要重置字段
    item.itemColorType = 0
    item.itemSpecialType = 0
}
SurpriseBonusItemDef = xClass("SurpriseBonusItemDef", BaseItemDef)
BigBoxItemDef = xClass("BigBoxItemDef", BaseItemDef)
BigBoxItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.bigBoxLevel = self.strength
}
CakeItemDef = xClass("CakeItemDef", BaseItemDef)
CakeItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.isBlock = true
    item.cakeLevel = self.strength
}
JamBoxItemDef = xClass("JamBoxItemDef", BaseItemDef)
JamBoxItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.itemType = self.itemType
    item.strength = self.strength
}
JamItemDef = xClass("JamItemDef", BaseItemDef)
JamItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
}
JamItemDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initBoardItem(self, board, mainLogic)
    board.jamLevel = self.strength
}
// OneLifeItemDef
OneLifeItemDef = xClass("OneLifeItemDef", BaseItemDef)
OneLifeItemDef.prototype.initGameItem = function (item, mainLogic) { }
OneLifeItemDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.oneLiftIgnore = true
}
// NoNuclearItemDef
NoNuclearItemDef = xClass("NoNuclearItemDef", BaseItemDef)
NoNuclearItemDef.prototype.initGameItem = function (item, mainLogic) { }
NoNuclearItemDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.noNuclear = true
}
BowknotItemDef = xClass("BowknotItemDef", BaseItemDef)
BowknotItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//------------
ScoreAnimalDef = xClass("ScoreAnimalDef", BaseItemDef)
ScoreAnimalDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.stepCountDown = GamePlayConfig_ScoreAnimal_Step_Init
}
//-------------------------------------------
ShellDef = xClass("ShellDef", BaseItemDef)
ShellDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.shellLevel = self.strength
}
//----------------------------------------------
SuperHoneyBottle = xClass("SuperHoneyBottle", BaseItemDef)
SuperHoneyBottle.prototype.initWithData = function (id, def) {
    let self = this
    // body
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.dir = def.dir
}
SuperHoneyBottle.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.itemColorType = 0
    item.honeyDirector = self.dir
    item.strength = self.strength
}
//-------------------------------------------
RiceBagDef = xClass("RiceBagDef", BaseItemDef)
RiceBagDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
}
GoldPackageDef = xClass("GoldPackageDef", BaseItemDef)
GoldPackageDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.lockLevel = self.strength
    item.isBlock = true
    item.lockType = self.lockType
}
CandyFlossDef = xClass("CandyFlossDef", BaseItemDef)
CandyFlossDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
}
CandyFlossDef.prototype.initBoardItem = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
}
//-------------------------------------------
RatelDef = xClass("RatelDef", BaseItemDef)
RatelDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    item.ratelDirection = self.id - GameItemType.kRatel + 1
}
//---------------------------------------------
VulnerableDef = xClass("VulnerableDef", BaseItemDef)
VulnerableDef.prototype.initWithData = function (id, def) {
    let self = this
    // body
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.dir = def.dir
}
VulnerableDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.lockType = self.lockType
    item.lockLevel = self.strength
    item.vulnerableDir = self.dir
    item.isUsed = true
    item.isBlock = true
}
CapsuleToyItemDef = xClass("CapsuleToyItemDef", BaseItemDef)
CapsuleToyItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.itemStrength = self.strength
}
GrassItemDef = xClass("GrassItemDef", BaseItemDef)
GrassItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.flowerRandoms = table(
        [0, mainLogic.randomValue(1, 8)],
        [0, mainLogic.randomValue(3, 5)],
        [0, mainLogic.randomValue(3, 5)]
    )
}
CandyCaneItemDef = xClass("CandyCaneItemDef", BaseItemDef)
CandyCaneItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
}
IceBombItemDef = xClass("IceBombItemDef", BaseItemDef)
IceBombItemDef.prototype.initGameItem = function (item, mainLogic, from, to) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    if (from && to) {
        item.iceBombCountDown = mainLogic.randomValue(from, to)
    }
}
IceBombItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
CakeShooterItemDef = xClass("CakeShooterItemDef", BaseItemDef)
CakeShooterItemDef.prototype.initGameItem = function (item, mainLogic, from, to, dir) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    if ($bool(dir)) {
        item.cakeShooterDirection = dir
    }
}
CakeShooterItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
SharkItemDef = xClass("SharkItemDef", BaseItemDef)
SharkItemDef.prototype.initGameItem = function (item, mainLogic, from, to, dir) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    if (dir || dir == 0) {
        item.sharkDirection = dir
    }
}
SharkItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
GummyWormItemDef = xClass("GummyWormItemDef", BaseItemDef)
GummyWormItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//---------------------------------------------
// NestDoll
//---------------------------------------------
NestDollItemDef = xClass("NestDollItemDef", BaseItemDef)
NestDollItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.coverType = self.coverType
    item.nestDollLevel = self.level
    item.coverStrength = self.strength
}
NestDollPriorityDef = xClass("NestDollPriorityDef", BaseItemDef)
NestDollPriorityDef.prototype.initWithData = function (id, def) {
    let self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.nestDollTypeList = table()
    table.insert(self.nestDollTypeList, def.nestDollType_1)
    table.insert(self.nestDollTypeList, def.nestDollType_2)
}
NestDollPriorityDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
}
NestDollPriorityDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    for (let i = 1, v = self.nestDollTypeList[1]; v; i++, v = self.nestDollTypeList[i]) {
        board.addNestDollToPriorityList(v)
    }
}
//---------------------------------------------
// BlastCrystal
//---------------------------------------------
BlastCrystalDef = xClass("BlastCrystalDef", BaseItemDef)
BlastCrystalDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
}
//---------------------------------------------
// Rocket
//---------------------------------------------
RocketDef = xClass("RocketDef", BaseItemDef)
RocketDef.prototype.initWithData = function (id, def) {
    let self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
}
RocketDef.prototype.initGameItem = function (item, mainLogic, from, to, direction) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    item.rocketDirection = direction || FourDirection.kUp
}
RocketDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
//---------------------------------------------
// Prop Block
//---------------------------------------------
PropBlockDef = xClass("PropBlockDef", BaseItemDef)
PropBlockDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    item.stepCountDown = GamePlayConfig_PropBlock_Step_Max
}
//---------------------------------------------
// Mint Block
MintBlockDef = xClass("MintBlockDef", BaseItemDef)
MintBlockDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
}
//---------------------------------------------
// Colored Frosting
//---------------------------------------------
ColoredFrostingItemDef = xClass("ColoredFrostingItemDef", BaseItemDef)
ColoredFrostingItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock()) {
        showError(item.y, item.x, self)
        return 
    }
    item.lockType = self.lockType
    item.lockColor = self.color
    item.lockLevel = self.strength
}
ColoredFrostingItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.lockColor === 0) {
        item.lockColor = mainLogic.randomColor()
    }
}
//---------------------------------------------
// Candy Yoyo
//---------------------------------------------
CandyYoyoDef = xClass("CandyYoyoDef", BaseItemDef)
CandyYoyoDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
}
//---------------------------------------------
// Jam Jar
//---------------------------------------------
JamJarDef = xClass("JamJarDef", BaseItemDef)
JamJarDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.isEmpty = false
    item.itemType = self.itemType
    item.strength = self.strength
    item.jamJarColor = self.color
}
//---------------------------------------------
// sea anemone
//---------------------------------------------
SeaAnemoneDef = xClass("SeaAnemoneDef", BaseItemDef)
SeaAnemoneDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
}
//---------------------------------------------
// mushroom
//---------------------------------------------
MushroomDef = xClass("MushroomDef", BaseItemDef)
MushroomDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
    item.mushroomLevel = self.strength
    item.biding = false
}
//---------------------------------------------
// fishnet
//---------------------------------------------
FishnetDef = xClass("FishnetDef", BaseItemDef)
FishnetDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
}
FishnetDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.fishnetLevel = self.strength
}
//---------------------------------------------
// UFO
//---------------------------------------------
UFODef = xClass("UFODef", BaseItemDef)
UFODef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.ufoLevel = self.strength
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
}
//---------------------------------------------
// FlashBird
//---------------------------------------------
FlashBirdDef = xClass("FlashBirdDef", BaseItemDef)
FlashBirdDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isBlock = true
    item.strength = 0
}
FlashBirdDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
FlashBirdDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.hasFlashBird = true
}
//---------------------------------------------
// CheeseRat
//---------------------------------------------
CheeseRatDef = xClass("CheeseRatDef", BaseItemDef)
CheeseRatDef.prototype.initWithData = function (id, def) {
    let self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.hadRat = def.hadRat
}
CheeseRatDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    item.cheeseRatHaveRat = self.hadRat
}
//---------------------------------------------
// Pastry
//---------------------------------------------
PastryDef = xClass("PastryDef", BaseItemDef)
PastryDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    item.itemType = self.itemType
    item.pastryLevel = self.strength
}
CroissantDef = xClass("CroissantDef", BaseItemDef)
CroissantDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
}
//---------------------------------------------
// 小章鱼
//---------------------------------------------
MiniOctopusDef = xClass("MiniOctopusDef", BaseItemDef)
MiniOctopusDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.itemType = self.itemType
    item.strength = self.strength
}
//---------------------------------------------
// PopCan
//---------------------------------------------
PopCanDef = xClass("PopCanDef", BaseItemDef)
PopCanDef.prototype.initGameItem = function (item, mainLogic, form, to, dir) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    //BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength || 3
    item.popCanDirection = dir || EightDirection.kUp
    item.isBlock = false
}
//---------------------------------------------
// Filbert
//---------------------------------------------
FilbertDef = xClass("FilbertDef", BaseItemDef)
FilbertDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
}
//---------------------------------------------
// FireWork
//---------------------------------------------
FireWorkDef = xClass("FireWorkDef", BaseItemDef)
FireWorkDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.strength = self.strength || 1
}
FireWorkDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
//---------------------------------------------
// FireCracker
//---------------------------------------------
FireCrackerDef = xClass("FireCrackerDef", BaseItemDef)
FireCrackerDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.strength = self.strength || 1
    item.itemColorType = 0
}
FireCrackerDef.prototype.addedToGameBoard = function (item, mainLogic) { }
//---------------------------------------------
// IcecreamCollector
//---------------------------------------------
IcecreamCollectorDef = xClass("IcecreamCollectorDef", BaseItemDef)
IcecreamCollectorDef.prototype.initGameItem = function (item, mainLogic, form, to, dir) {
    let self = this
    // body
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength || 5
    if (item.itemType === GameItemType.kAnimal) {
        item.itemType = 0
        item.itemColorType = 0
        item.isFallVertical = false
        item.isEmpty = true
    }
}
//---------------------------------------------
// Icecream
//---------------------------------------------
IcecreamDef = xClass("IcecreamDef", BaseItemDef)
IcecreamDef.prototype.initGameItem = function (item, mainLogic, form, to, dir) {
    let self = this
    item.isUsed = true
}
IcecreamDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    // body
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.icecreamLevel = self.strength
}
//-----------------------------------------
// Lamp
//----------------------------------------
LampItemDef = xClass("LampItemDef", BaseItemDef)
LampItemDef.prototype.initWithData = function (id, def) {
    let self = this
    // BaseItemDef.prototype.initWithData(self, id, def)
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.isHead = def.isHead
}
LampItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.lampLighted = false
    item.lampHead = self.isHead
    mainLogic.lampBoomCheck = true
}
//-----------------------------------------
// 激光炮
//----------------------------------------
LaserItemDef = xClass("LaserItemDef", BaseItemDef)
LaserItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
}
//-----------------------------------------
// 奖券
//----------------------------------------
QualifyHatItemDef = xClass("QualifyHatItemDef", BaseItemDef)
QualifyHatItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.qualifyHat = true
    mainLogic.qualifyHatOpen = true
}
//-----------------------------------------
// 彩蛋
//----------------------------------------
EggItemDef = xClass("EggItemDef", BaseItemDef)
EggItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.itemColorType = 0
    item.itemSpecialType = 0
    item.strength = self.strength || 1
}
//-----------------------------------------
// 染色地格
//----------------------------------------
DyeItemDef = xClass("DyeItemDef", BaseItemDef)
DyeItemDef.prototype.initWithData = function (id, def) {
    let self = this
    self.id = tonumber(id)
    self.color = def.color || null
    self.special = def.special || null
    self.strength = def.strength || null
    self.level = def.level || 0
    self.lockType = def.lockType || null
    self.coverType = def.coverType || null
    self.ceilType = def.ceilType || null
}
DyeItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    //BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    //item.itemColorType = self.color
    item.isUsed = true
}
DyeItemDef.prototype.initBoardItem = function (board, mainLogic) {
    let self = this
    BaseItemDef.prototype.initBoardItem.call(self, board, mainLogic)
    board.dyecolor = self.color
}
//-----------------------------------------
// 魔法瓶
//----------------------------------------
MagicbottleItemDef = xClass("MagicbottleItemDef", BaseItemDef)
MagicbottleItemDef.prototype.initGameItem = function (item, mainLogic, id, count) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    //BaseItemDef.prototype.initGameItem(self, item, mainLogic)
    item.isUsed = true
    if (item.itemSpecialType === AnimalTypeConfig.kColor) {
        item.magicbottleCount = 0
        item.magicbottleTotalCount = 0
        item.magicbottleId = 46
    } else {
        if (id) {
            item.magicbottleId = id
        }
        if (count) {
            item.magicbottleCount = count
            item.magicbottleTotalCount = count
            if (count <= 0) {
                item.itemSpecialType = AnimalTypeConfig.kColor
            }
        }
    }
}
//-----------------------------------------
// 餐桌
//----------------------------------------
DinnertableItemDef = xClass("DinnertableItemDef", BaseItemDef)
DinnertableItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
}
//-----------------------------------------
// 糖衣炮弹
//----------------------------------------
BombCandyItemDef = xClass("BombCandyItemDef", BaseItemDef)
BombCandyItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.strength = self.strength
    if (item.strength > 0) {
        item.itemColorType = 0
    }
}
BombCandyItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    if (item.itemColorType === 0 && item.strength <= 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
//-----------------------------------------
// 鱼雷
//----------------------------------------
TorpedoItemDef = xClass("TorpedoItemDef", BaseItemDef)
TorpedoItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = self.strength
    if (item.itemColorType === 0) {
        item.itemColorType = mainLogic.randomColor()
    }
}
//-----------------------------------------
// 饼干
//----------------------------------------
BiscuitItemDef = xClass("BiscuitItemDef", BaseItemDef)
BiscuitItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.strength = self.strength
    item.lockLevel = self.strength
}
BiscuitItemDef.prototype.addedToGameBoard = function (item, mainLogic) {
    let self = this
    //local value = mainLogic:randomValue(1,4)
    //item.strength = value
    //item.lockLevel = value
    // 如果同格存在小动物，则移除小动物数据
    /* if item.itemType == GameItemType.kAnimal then
        item.itemType = 0
        item.itemColorType = 0
        item.isFallVertical = false
        item.isEmpty = true
    end */
}
//-----------------------------------------
// 爆米花
//----------------------------------------
PopcornItemDef = xClass("PopcornItemDef", BaseItemDef)
PopcornItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.itemColorType = 0
}
//-----------------------------------------
// 鸟窝
//----------------------------------------
NestDef = xClass("NestDef", BaseItemDef)
NestDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
}
NestDef.prototype.initBoardItem = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
}
//-----------------------------------------
//赏金猎人
//-----------------------------------------
HunterItemDef = xClass("HunterItemDef", BaseItemDef)
HunterItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.lockType = self.lockType
}

//------------------------------------------------------------------------
//-钻石空心（必须覆盖棋子）
//------------------------------------------------------------------------
DiamondItemDef = xClass("DiamondItemDef", BaseItemDef)
DiamondItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    // body
    item.isUsed = true
    item.diamondLevel = self.strength
}
//------------------------------------------------------------------------
//-钻石实心（不能覆盖棋子）
//------------------------------------------------------------------------
DiamondSolidItemDef = xClass("DiamondSolidItemDef", BaseItemDef)
DiamondSolidItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.itemColorType = 0
    item.itemSpecialType = 0
    item.diamondLevel = self.strength
}
TurnTileAItemDef = xClass("TurnTileAItemDef", BaseItemDef)
TurnTileAItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.turnTile = "A"
    item.isEmpty = true
}
TurnTileBItemDef = xClass("TurnTileBItemDef", BaseItemDef)
TurnTileBItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.turnTile = "B"
    item.isEmpty = true
}
TurnTileControlAItemDef = xClass("TurnTileControlAItemDef", BaseItemDef)
TurnTileControlAItemDef.prototype.initWithData = function (id, def) {
    let self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.strength = def.strength || 1
    self.lockType = def.lockType
}
TurnTileControlAItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.turnTileControl = "A"
    item.strength = self.strength || 1
    item.turnTileControlRawStrength = item.strength
}
TurnTileControlBItemDef = xClass("TurnTileControlBItemDef", BaseItemDef)
TurnTileControlBItemDef.prototype.initWithData = function (id, def) {
    let self = this
    BaseItemDef.prototype.initWithData.call(self, id, def)
    self.strength = def.strength || 1
    self.lockType = def.lockType
}
TurnTileControlBItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.turnTileControl = "B"
    item.strength = self.strength || 1
    item.turnTileControlRawStrength = item.strength
}//-----------------------------------------
// 小鱼罐头
//----------------------------------------
CannedFishItemDef = xClass("CannedFishItemDef", BaseItemDef)
CannedFishItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    //BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
    item.lockLevel = 1
}
//---------------------------------------------
// 泡沫炸弹
//---------------------------------------------
FoamBombDef = xClass("FoamBombDef", BaseItemDef)
FoamBombDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.itemType = self.itemType
    item.strength = self.strength
    item.itemColorType = 0
    item.isEmpty = false
}
//-----------------------------------------
//冰棒盒子
//-----------------------------------------
IcePopBoxItemDef = xClass("IcePopBoxItemDef", BaseItemDef)
IcePopBoxItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.itemType = self.itemType
    item.strength = self.strength
}
//-----------------------------------------
//保险箱
//-----------------------------------------
SafeItemDef = xClass("SafeItemDef", BaseItemDef)
SafeItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.lockType = self.lockType
}
//-----------------------------------------
//马戏团
//-----------------------------------------
CircusItemDef = xClass("CircusItemDef", BaseItemDef)
CircusItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    item.itemColorType = 0
    item.itemSpecialType = 0
}
//-----------------------------------------
//马戏团金币
//-----------------------------------------
CircusBallItemDef = xClass("CircusBallItemDef", BaseItemDef)
CircusBallItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.strength = self.strength
    item.itemColorType = 0
    item.itemSpecialType = 0
}
//-----------------------------------------
//木箱
//-----------------------------------------
WoodBoxItemDef = xClass("WoodBoxItemDef", BaseItemDef)
WoodBoxItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    item.isUsed = true
    item.isBlock = true
    if (item.hasLock() && item.lockType !== LockItemType.kMushroom) {
        showError(item.y, item.x, self)
        return 
    }
    item.wood_box_level = self.strength
}
MangosteenItemDef = xClass("MangosteenItemDef", BaseItemDef)
MangosteenItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isBlock = true
    item.isUsed = true
    item.strength = self.strength
}
//-----------------------------------------
// 应援棒
//----------------------------------------
SupportStickItemDef = xClass("SupportStickItemDef", BaseItemDef)
SupportStickItemDef.prototype.initGameItem = function (item, mainLogic) {
    let self = this
    BaseItemDef.prototype.initGameItem.call(self, item, mainLogic)
    item.isUsed = true
    item.isBlock = true
    item.lockType = self.lockType
}
